import { Link } from "react-router-dom";
import type { EventItem } from "@/types";
import EventCard from "@/components/feature/EventCard";
import SectionHeading from "@/components/base/SectionHeading";
import { EventCardSkeleton } from "@/components/base/Skeleton";

interface TodayEventsProps {
  events: EventItem[];
  loading: boolean;
}

export default function TodayEvents({ events, loading }: TodayEventsProps) {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="w-full">
        <SectionHeading
          eyebrow="Today's Fixtures"
          title="今日赛事快讯"
          desc="汇总当天正在进行与即将开始的比赛，助你第一时间掌握赛程动态。"
          action={
            <Link
              to="/schedule"
              className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
            >
              查看全部赛程 <i className="ri-arrow-right-line" />
            </Link>
          }
        />

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {Array.from({ length: 6 }).map((_, i) => (
              <EventCardSkeleton key={i} />
            ))}
          </div>
        ) : events.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <i className="ri-calendar-close-line text-4xl text-foreground-300" />
            <p className="mt-3 text-sm text-foreground-500">今日暂无赛事，敬请期待</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {events.map((e) => (
              <EventCard key={e.id} event={e} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}